import { Messages } from '../../../../codegen/Localize';
import { IScheduleInfo } from '../../../../ts/models/IScheduleInfo';
import { scheduleRunNow } from '../../../actions/spaces/ScheduleMenuActions';
import { appStore } from '../../../AppStore';
import { AppState } from '../../../state/AppState';
import { hasRunNowPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanRunSchedule } from './IEntityActionHelpers';

export const ScheduleRunNowAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.SchedulesRunNow,
  translateName: Messages.runNow_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanRunSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return hasRunNowPermission(appStore.getState());
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleRunNow(targetItems)
};
